/**
 * Created by H
 * User: huangcan
 * Date: 2019-08-20
 * Time: 20:36
 * tips: 图片上传
 */
export default {
  data() {
    return {
      isUpload: true
    }
  },
  methods: {
    /**
     * 图片文件和额外参数信息追加到formData
     * @param field
     * @param data
     * @param file
     */
    _appendFormDataInfo() {
      const argv = [...arguments]
      const data = argv.shift()
      const file = argv.pop()
      let field = argv[0]
      data.some((v, i) => {
        if (v.uid === file.file.uid) {
          field = field || `image_file`
          this.formData.append(`${field}${v.uid}_${i}`, file.file)
          return true
        }
      })
    },
    /**
     * 限制图片张数
     */
    handleExceed(files, fileList) {
      this.$notify({
        type: 'warning',
        message: `当前限制选择 10 个文件，本次选择了 ${
          files.length
        } 个文件，共选择了 ${files.length + fileList.length} 个文件`
      })
    },
    /**
     *  上传
     * @param field
     * @private
     */
    _handleUpload(...field) {
      this.formData = new FormData()
      field.forEach(v => {
        this.$refs[v].submit()
      })
    },
    /**
     * 图片移除
     * @param str
     * @param file
     * @param fileList
     */
    handleRemove(str, file, fileList) {
      const del = () => {
        if (str.includes('.')) {
          const arr = str.split('.')
          this[arr[0]][arr[1]] = fileList
        } else {
          this[str] = fileList
        }
        this.$notify({
          type: 'success',
          message: '删除成功啦~！😄'
        })
      }
      if (file.status === 'success' && !file.merge) {
        if (file.albumId || file.album_id) {
          // 删除图片
          const params = {
            album_id: file.albumId || file.album_id,
            picture_id: file.picId || file.picture_id,
            mark: file.mark,
            class_name: file.className,
            secondary_class: file.secondClass,
            picture_url: file.url
          }
          this.api.pictureDel(params).then(() => {
            del()
          })
        } else {
          const params = {
            mark: 'brand',
            file_id: this.$route.query.brand_id || this.form.brandId,
            file_url: file.url
          }
          this.api.fileDelete(params).then(() => {
            del()
          })
        }
      } else {
        del()
      }
    },
    /**
     * 图片预览
     * @param file
     */
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    /**
     * 添加图片信息
     * @param str
     * @param callback
     * @param file
     * @param fileList
     */
    handleAddItemData() {
      const argv = [...arguments]
      const str = argv.shift()
      const fileList = argv.pop()
      const callback = argv[0]
      const file = argv[1]
      if (str.includes('.')) {
        const arr = str.split('.')
        this[arr[0]][arr[1]] = fileList
      } else {
        this[str] = fileList
      }
      if (typeof callback === 'function') {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          callback(file)
        }, 300)
      }
    },
    /**
     * 限制大小
     * @param file
     * @param size
     */
    _beforeLimitUpload(file, size) {
      const s = size || 2
      const isLt2M = file.size / 1024 / 1024 < s
      if (!isLt2M) {
        this.$notify({
          type: 'error',
          message: '上传文件大小超过限制!'
        })
      }
      this.fileList = []
      this.isUpload = isLt2M
    }
  }
}
